import BaseApi from './BaseApi'

export default class DeviceCommandApi extends BaseApi {
    async requestVideo (params = {
        hardwareId: null,
        eventId: null,
        date: null,
        channels: null,
        videoLengthInSeconds: null,
        withOverlay: null,
        positionMetadata: null,
    }) {
        let response = await this.post(`/api/v1.0/devicesCommands/request/video`, {
            hardwareId: params.hardwareId,
            channels: params.channels,
            videoLengthInSeconds: params.videoLengthInSeconds,
            withOverlay: params.withOverlay,
            utcDate: params.date,
            eventId: params.eventId,
            positionMetadata: params.positionMetadata
        })

        return response;
    }

    async requestSnapshot (params = {
        hardwareId: null,
        eventId: null,
        date: null,
        channels: null,
        videoLengthInSeconds: null,
        withOverlay: null,
        positionMetadata: null,
    }) {
        let response = await this.post(`/api/v1.0/devicesCommands/request/snapshot`, {
            hardwareId: params.hardwareId,
            channels: params.channels,
            videoLengthInSeconds: params.videoLengthInSeconds,
            withOverlay: params.withOverlay,
            utcDate: params.date,
            eventId: params.eventId,
            positionMetadata: params.positionMetadata
        })

        return response;
    }
}
